import { useContext } from 'react';

import { SummaryContext } from './summary-provider';

export default () => useContext(SummaryContext);
